import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import './styles/Projects.css';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API_URL}/projects`);
        setProjects(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load projects');
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  if (loading) return <div className="loading-text">Loading...</div>;
  if (error) return <div className="error-text">{error}</div>;

  return (
    <div className="projects-container">
      {projects.map((project) => (
        <div key={project._id} className="project-card">
          <div className="project-info">
            <h2 className="project-title">{project.name}</h2>
            
            <div className="project-details">
              <div className="project-section">
                <h3>PROJECT INFORMATION</h3>
                <p>{project.description.split('\n')[0]}</p>
              </div>

              <div className="project-section">
                <h3>PROJECT DESCRIPTION</h3>
                <p>{project.description.split('\n')[1] || 'No detailed description available.'}</p>
              </div>
            </div>
          </div>

          <div className="project-images">
            {project.images.slice(0, 4).map((image, index) => (
              <div key={index} className="image-container">
                <img
                  src={image}
                  alt={`${project.name} - ${index + 1}`}
                  className="project-image"
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Projects;
